import { render, staticRenderFns } from "./DesignHistory.vue?vue&type=template&id=c9db4860"
import script from "./DesignHistory.vue?vue&type=script&lang=js"
export * from "./DesignHistory.vue?vue&type=script&lang=js"
import style0 from "./DesignHistory.vue?vue&type=style&index=0&id=c9db4860&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports